import moment from "moment"
import 'moment/locale/ko';

export const Moments = {
  MomentsISODate: (dateTime) => {
    return moment(dateTime).format("YYYY-MM-DD");
  },
  MomentsDay: (dateTime) => {
    return moment(dateTime).format("MM-dd");
  },
  MomentsMonth: (dateTime) => {
    return moment(dateTime).format("M");
  },
  MomentsDate: (dateTime) => {
    return moment(dateTime).format("DD");
  },
  Diff : (dateTime, twoDateTime) => {
    return moment(dateTime).diff(moment(twoDateTime), 'milliseconds');
  },
  Diff2 : (dateTime, twoDateTime) => {
    return moment.duration(moment(dateTime).diff(moment(twoDateTime))).asMilliseconds();
  },
  Diff_Days : (dateTime, twoDateTime) => {
    return moment.duration(moment(dateTime).diff(moment(twoDateTime))).asDays();
  },
  isToday : (dateTime) => {
    return moment().isSame(moment(dateTime), 'day');
  },
  isAfter : (dateTime, secondDateTime) => {
    return moment(dateTime).isAfter(moment(secondDateTime));
  },
  isBefore : (dateTime, secondDateTime) => {
    return moment(dateTime).isBefore(moment(secondDateTime));
  },
  Format: (dateTime, format) => {
    return moment(dateTime).format(format);
  },
  Today: () => {
    return moment();
  },
  adDays: (days) => {
    return moment().add(days, 'day');
  },
  ToMoment: (dateTime) => {
    return moment(dateTime);
  }
};
